<template>
  <div v-if="showBanner" class="notification-banner">
    <div class="notification-banner-content">
      <p class="notification-banner-text">The 2023 award winners are announced!</p>
      <button @click="goToAwards()" class="notification-banner-button">View Award Winners <i class="pl-2 fa-regular fa-arrow-right-long isef-home-banner-hero-btn-icon"></i></button>
    </div>
  </div>
</template>

<script>
import auth from '@/mixins/auth'

export default {
  mixins: [auth],
  computed: {
    showBanner: function () {
      return this.$isIsef && this.showOnPage
    },
    showOnPage: function () {
      // Hide on award viewAll pages, and show on specific routes
      return !this.$route.query.awardID && ['/', '/categories', '/viewAll', '/sponsors', '/society-for-science', '/special-award-organizations', '/college-career-fair'].includes(this.$route.path)
    }
  },
  methods: {
    scrollToCategory: function () {
      setTimeout(() => {
        const selectAllCat = document.querySelector('a.categories-sponsors-text:not(.is-inactive)')
        if (selectAllCat) {
          // Extra wait time for the page to load on home page
          setTimeout(() => {
            selectAllCat.scrollIntoView({
              behavior: 'smooth'
            })
          }, 1000)
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }, 1000)
    },
    goToAwards: function () {
      this.$router.push({ name: 'home' }).then(() => {
        this.scrollToCategory()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.notification-banner {
  font-size: 1rem;
  color: white;
  width: 100%;
  text-align: center;
  align-items: center;
  background: linear-gradient(90deg, rgba(51, 117, 193, 0.9) 0%, rgba(204, 75, 121, 0.9) 40.1%, rgba(223, 142, 68, 0.9) 70.83%, rgba(255, 213, 99, 0.9) 100%);
  &-content {
    height: 4rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  &-text {
    margin: 0 20px 0 0;
    @include mobile {
      display: none;
    }
  }
  &-button {
    font-size: 1rem;
    cursor: pointer;
    padding: 10px 22px;
    color: white;
    background: transparent;
    border-radius: 10px;
    border: solid 3px white;
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}

</style>
